<template>
    <div class="dacal-h5" id="app">
      <van-pull-refresh v-model="loading" @refresh="onRefresh">
        <UserInfo v-if="!alertWin"/>
        <router-view/>
        <BottomMenu v-if="!alertWin"/>
      </van-pull-refresh>
    </div>
</template>

<script>
import store from "@/store";
import DataDesc from "@/views/DataDesc.vue";
import UseRegister from "@/views/UseRegister.vue";
import UserInfo from "@/components/UserInfo.vue";
import {getUrlParam} from '@/utils/util';
import PrivacyPolicy from "@/views/PrivacyPolicy.vue";
import {Button} from "vant";
import BottomMenu from "@/components/BottomMenu.vue";
import {onMounted, ref, watch} from "vue";


export default {
    name: 'App',
    components: {
      BottomMenu,
        Button,
        PrivacyPolicy,
        UseRegister,
        DataDesc,
        UserInfo,
    },
    setup() {
        let userStore = store.userStore();
        let deviceId = getUrlParam('deviceId');
        let appVersion = getUrlParam('appVersion');
        let dataType = getUrlParam('data');
        let bizType = getUrlParam("bizType");
        let winType = getUrlParam("winType");

        let loading = ref(false);

        if (deviceId) {
            userStore.saveDeviceId(deviceId);
            bizType = null;

            if(deviceId.startsWith("family")){
              bizType = "FamilyMember";
            }else if(deviceId.startsWith("doumi")){
              bizType = "DoumiMember";
            }else{
              bizType = "DataMember";
            }


            userStore.saveBizType(bizType);
        }

        if(appVersion){
          userStore.saveAppVersion(appVersion);
        }

        if(dataType && dataType !== "yolo"){
          userStore.saveDataType(dataType);
        }else{
          userStore.saveDataType("liaoyu");
        }

        const url = location.href;
        const onRefresh = () => {
          location.href = url;
          loading.value = false;
        };

        return {deviceId,loading,onRefresh, alertWin: winType === "alert"};
    }
}
</script>

<style lang="less">
@import '@/app.less';

#app {
  min-width:360px;
  font-size: 14px;
  padding-bottom: 50px;
  font-family: @font;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: @black2;
    .download-wrap{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .van-theme-dark {
        --van-text-color: #f5f5f5;
        --van-text-color-2: #707070;
        --van-text-color-3: #4d4d4d;
        --van-border-color: #3a3a3c;
        --van-active-color: #3a3a3c;
        --van-background: #000;
        --van-background-2: #1c1c1e;
        --van-background-3: #37363b
    }
  .van-tabbar-item{
    border-top: transparent solid 0.2rem;
  }
  .van-tabbar-item--active{
    color: @black1;
    font-weight: bold;
    background: #f0f0f0;
  }
}

.content-wrap{
  padding: 1rem 2rem;
  .line-text{
    display: flex;
    line-height: 2rem;
    align-items: center;
    text-align: left;
    font-size: 14px;
    .line-label{
      padding-right: 1rem;
      text-align: left;
      font-weight: bold;
    }
    .line-content{
      display: flex;
      align-items: center;
    }
  }
  .button-wrap{
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px dashed @gray1;
  }
  .van-tag--info{
    background-color: @black2;
  }
}

@supports (-webkit-touch-callout: none) {
  #app {
    padding-bottom: 50px !important;
    /* 或使用计算属性 */
    padding-bottom: calc(50px + constant(safe-area-inset-bottom)) !important;
    padding-bottom: calc(50px + env(safe-area-inset-bottom)) !important;
  }
}

</style>
